import React, { useEffect, useRef, useState } from "react";

interface OTPInputProps {
  n?: number;
  onChange: (value: string) => void;
  callback?: (value: string) => void;
  classname?: string;
}

export default function OTPInput(props: OTPInputProps) {
  const { n = 6, onChange, callback, classname, ...restProps } = props;
  const [value, setValue] = useState<string[]>(Array(n).fill(""));
  const inputRefs = useRef<HTMLInputElement[]>(Array(n).fill(null));

  useEffect(() => {
    if (value.every((val) => val && val !== "")) {
      onChange(value.join(""));
    }
  }, [value, onChange]);

  function handleValue(ev: React.ChangeEvent<HTMLInputElement>, i: number) {
    const val = ev.target.value;
    const temp = [...value];
    temp[i] = val;

    if (val !== "" && i + 1 < inputRefs.current.length) {
      inputRefs.current[i + 1]?.focus();
    }

    setValue(temp);
  }

  function handleBackspace(
    ev: React.KeyboardEvent<HTMLInputElement>,
    i: number
  ) {
    if (ev.key === "Backspace") {
      const temp = [...value];
      temp[i] = "";

      if (i - 1 >= 0) {
        inputRefs.current[i - 1]?.focus();
      }

      setValue(temp);
    }

    if (value.every((val) => val && val !== "")) {
      callback && callback(value.join(""));
    }
  }

  return (
    <div className={`flex gap-2 w-full ${classname}`}>
      {value.map((val, i) => (
        <div className="flex flex-1 justify-center" key={i}>
          <input
            type="text"
            {...restProps}
            value={val || ""}
            maxLength={1}
            tabIndex={i + 1}
            ref={(el) => (inputRefs.current[i] = el as HTMLInputElement)}
            onKeyUp={(ev) => handleBackspace(ev, i)}
            onChange={(ev) => handleValue(ev, i)}
            className="border border-primary/20 rounded-lg w-full max-w-[55px] h-[50px] p-1 sm:p-3 text-[20px] text-center"
          />
        </div>
      ))}
    </div>
  );
}
